<template>
  <div>
    <div class="account-pages w-100 mt-5 mb-5">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="card card-radius">
                        <div class="backgroundColorRed card-radius-top topBorderCard"></div>
                        <div class="card-body p-8">
                            <div class="text-center mb-4">
                                <a href="index.html">
                                    <span><img src="assets/images/logo_preto@2x.png" alt="" height="60px"></span>
                                </a>
                            </div>
                            <form action="#" class="pt-2">
                                <div class="form-group mb-3">
                                    <input class="input-text form-control" type="email" v-model="data.email" required="" :placeholder="$t('string.msg.login.placeholder.email')">
                                </div>
                                <div class="form-group mb-3">
                                    <input class="input-text form-control" type="password" required="" v-model="data.password" :placeholder="$t('string.msg.login.placeholder.password')">
                                </div>
                                <br>
                                <div class="container-fluid">
                                    <div class="col-sm-12 text-center">
                                        <input type="button" class="btn btn-danger btn-login" @click="submit" :value="$t('string.msg.login.btn.login')"/>
                                    </div>
                                </div>
                            </form>
                            <br>
                            
                            <div class="text-center mb-4">
                                <a @click="checkForgotPassword()" class="cursor-pointer">
                                    <a  class="text-muted underline" > <small>{{$t('string.login.forgot.password')}}</small></a>
                                </a>
                            </div>
<!-- <>
                            <div class="text-center mb-4">
                                <img class="margin-side-items" src="assets/images/ic_google@2x.png" width="41px" height="40px">
                                <img class="margin-side-items" src="assets/images/ic_facebook@2x.png" width="41px" height="40px">
                            </div> -->

                            <br><br>

                            <div class="text-center mb-4">
                                <a class="text-muted underline"><small>{{$t('string.msg.login.text.signup')}}</small></a>
                                <br/>
                                <a @click="register()" class="cursor-pointer">
                                    <a class="text-muted underline"><small><b>{{$t('string.msg.login.label.signup')}}</b></small></a>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a
            class="whatsapp-link"
            href="https://web.whatsapp.com/send?phone=5511999676510"
            target="_blank"
          >
          <img 
            src="https://i.imgur.com/ryESuZ5.png"
            data-selector="img">
          </a>
    </div>
    <Spinner />
    <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast"/>
    <ModalForgotPassword v-on:check-code="checkCode" :data="data" :errors="errors"/>
    <ModalNewPassword v-on:reset-pass="resetPass" :data="data" :errors="errors"/>
  </div>
</template>

<script>
import axios from 'axios';
import ModalForgotPassword from './Modal/ModalForgotPassword';
import ModalNewPassword from './Modal/ModalNewPassword';
import Controller from './CrtLogin';
import Spinner from '../../components/layout/Spinner';
import Toast from '../../components/layout/Toast';

export default {
  name: 'Login',
  components: {
    ModalForgotPassword,
    ModalNewPassword,
    Spinner,
    Toast
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        data: {
          email: "",
          password: "",
          passwordConfirm: null,
          code: null,
          systemUser: null
        },
        user: null,
      }
  },
  methods: Controller.methods,
  sockets: {
        connect: function () {
            console.log('socket connected')
        },
        customEmit: function (data) {
            console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        }
    },
  created() {
    Controller.init(this);
  }
}
</script>

<style>
</style>
